import { FocusMonitor } from '@angular/cdk/a11y'
import { Component, ElementRef, OnInit, Optional, Self } from '@angular/core'
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms'
import { MatFormFieldControl } from '@angular/material/form-field'
import { CrudService, InsuranceProviderLookup } from '@mmx/shared'
import { orderBy } from 'lodash'

import { ChipsSelectorInputComponent } from '../chips-selector'

@Component({
  selector: 'mmx-carrier-lookups-selector-input',
  templateUrl: '../chips-selector/chips-selector.component.html',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: CarrierLookupsSelectorInputComponent,
    },
  ],
  standalone: false,
})
export class CarrierLookupsSelectorInputComponent
  extends ChipsSelectorInputComponent<InsuranceProviderLookup>
  implements OnInit
{
  protected _placeholder = 'Insurance Carriers'

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Optional() protected parentForm: NgForm,
    @Optional() protected parentFormGroup: FormGroupDirective,
    protected fm: FocusMonitor,
    protected elRef: ElementRef,
    private crud: CrudService,
  ) {
    super(ngControl, parentForm, parentFormGroup, fm, elRef)
  }

  ngOnInit() {
    super.ngOnInit()

    this.crud
      .index(InsuranceProviderLookup)
      .subscribe((lookups) => {
        this.setAvailableItems(orderBy(lookups, 'clinicCarrierName'))
      })
  }

  getItemId(item: InsuranceProviderLookup) {
    return item.id
  }
}
